import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavbarComponent } from "../../partials/navbar/navbar.component";
import { FooterComponent } from "../../partials/footer/footer.component";
import { CommonModule } from '@angular/common';

import * as AOS from 'aos';
import { LanguageService } from '../../services/language.service';
import { PartnersCarrouselComponent } from "../../components/partners-carrousel/partners-carrousel.component";



@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [NavbarComponent, FooterComponent, CommonModule, PartnersCarrouselComponent],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.css'
})
export class LandingComponent implements OnInit {

  @ViewChild('videoElement', { static: true }) videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('videoLlanta', { static: true }) videoLlanta!: ElementRef<HTMLVideoElement>;
  @ViewChild('videoPerformance', { static: true }) videoPerformance!: ElementRef<HTMLVideoElement>;

  isMuted: boolean = true;
  showControls: boolean = false;
  showPlayButton: boolean = false;
  isPlaying: boolean = false;
  autoplayAttempted: boolean = false;

  constructor(private langServ: LanguageService) { }

  texts:any;

  ngOnInit(): void {
    // Initialization logic can go here
    if (typeof document !== 'undefined') {
      AOS.init({
        duration: 750, // values from 0 to 3000, with step 50ms
        delay: 150,    // values from 0 to 3000, with step 50ms
        once: true,   // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
      });
    }

    this.texts = this.langServ.getWebisteTexts().home;
  }
  
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.videoElement?.nativeElement && typeof this.videoElement.nativeElement.pause === 'function') {
      this.videoElement.nativeElement.pause();
    }

    if (this.videoLlanta?.nativeElement && typeof this.videoLlanta.nativeElement.pause === 'function') {
      this.videoLlanta.nativeElement.pause();
    }

    if (this.videoPerformance?.nativeElement && typeof this.videoPerformance.nativeElement.pause === 'function') {
      this.videoPerformance.nativeElement.pause();
    }
  }

  onVideoLoaded(): void {
    //console.log('Video metadata loaded');
    this.attemptAutoplay();
  }

  async attemptAutoplay(): Promise<void> {
    if (this.autoplayAttempted) return;
    
    const video = this.videoElement.nativeElement;
    const videoLlanta = this.videoLlanta.nativeElement;
    const videoPerformance = this.videoPerformance.nativeElement;
    this.autoplayAttempted = true;

    try {
      // Ensure video is muted for autoplay
      video.muted = true;
      videoLlanta.muted = true;
      videoPerformance.muted = true;
      this.isMuted = true;
      
      // Attempt to play
      await video.play();
      await videoLlanta.play();
      await videoPerformance.play();
      //console.log('Autoplay successful');
      this.isPlaying = true;
      this.showPlayButton = false;
      
    } catch (error) {
      //console.log('Autoplay failed:', error);
      this.showPlayButton = true;
      this.isPlaying = false;
    }
  }

  async playVideo(): Promise<void> {
    const video = this.videoElement.nativeElement;
    const videoLlanta = this.videoLlanta.nativeElement;
    const videoPerformance = this.videoPerformance.nativeElement;
    
    try {
      // User interaction allows unmuted playback
      video.muted = false;
      videoLlanta.muted = false;
      videoPerformance.muted = false;
      this.isMuted = false;
      
      await video.play();
      await videoLlanta.play();
      this.isPlaying = true;
      this.showPlayButton = false;
      this.showControls = true;
      
    } catch (error) {
      //console.error('Play failed:', error);
      // Fallback to muted play
      try {
        video.muted = true;
        videoLlanta.muted = true;
        videoPerformance.muted = true;
        this.isMuted = true;
        await video.play();
        await videoLlanta.play();
        this.isPlaying = true;
        this.showPlayButton = false;
      } catch (fallbackError) {
        //console.error('Muted play also failed:', fallbackError);
      }
    }
  }
}
